import React from "react";

export const Bolt: React.FC<
  Pick<React.ComponentPropsWithoutRef<"svg">, "className">
> = ({ className }) => {
  return (
    <svg
      className={className}
      width="824"
      height="834"
      viewBox="0 0 824 834"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
    >
      <path
        d="M492.41 492.337L0.0481374 833.951L536.362 88.4775L567.456 339.671L972.573 -30.3895L1085.09 321.206L499.271 684.671L492.41 492.337Z"
        fill="#D6C7F9"
      />
    </svg>
  );
};
